import { render, staticRenderFns } from "./CompanyApplyCard.vue?vue&type=template&id=df8c0d6e&scoped=true&"
import script from "./CompanyApplyCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyApplyCard.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyApplyCard.vue?vue&type=style&index=0&id=df8c0d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8c0d6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBtn,VDivider,VIcon,VImg,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
